<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Audit History</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <span class="subheading"><b>Filters:</b></span>
                        <v-icon v-if="showFilters" @click="showFilters = !showFilters">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showFilters" @click="showFilters = !showFilters">fal fa-chevron-down</v-icon>
                    </v-layout>
                        <v-form v-model="valid" v-if="showFilters" @submit.prevent>
                    <v-layout wrap>
                        <v-flex xs11>
                            <v-layout wrap>
                                <v-flex xs2 ml-4 v-if="!orgIdProp">
                                    <v-autocomplete
                                    v-model="orgId"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="User Id" v-model="userId"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Entity Id" v-model="entityId"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Entity Name" v-model="entityName" :items="entityNames"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Event Type" v-model="eventType" :items="eventTypes"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Text" v-model="text"></v-text-field>
                                </v-flex>
                                <v-flex xs4 ml-4>
                                    <div class="date-time-container">
                                        <span class="date-selection-wrapper">
                                        <date-selection
                                            :min-date="minDate"
                                            :max-date="maxDate"
                                            :date-text="dateText"
                                            :value="dateValue"
                                            @range-selected="handleDateRangeUpdate"
                                        ></date-selection>
                                        </span>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                            <button onsubmit="false" class="btn btn-primary" @click="applyFilters" :disabled="!valid">Apply</button>
                            <button onsubmit="false" class="btn btn-default" @click="resetFilters">Reset</button>
                        </v-flex>
                    </v-layout>
                        </v-form>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="auditHistory.content"
                              :loading="loading"
                              :headers="headers"
                              :options.sync="pagination"
                              :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
                              :server-items-length="totalItems" class="elevation-1"
                            >
                            <template v-slot:item.updatedDate="{item}">
                                <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                              <template v-if="!orgIdProp" v-slot:item.orgId="{item}">
                                <td>{{item.org ? item.org.id : null}}</td>
                              </template>
                              <template v-if="!orgIdProp" v-slot:item.orgName="{item}">
                                <td>{{item.org ? item.org.name : null}}</td>
                              </template>
                              <template v-slot:item.userId="{item}">
                                <td>{{item.userId}}</td>
                              </template>
                              <template v-slot:item.entityId="{item}">
                                <td>{{item.entityId}}</td>
                              </template>
                              <template v-slot:item.entityName="{item}">
                                <td>{{item.entityName}}</td>
                              </template>
                              <template v-slot:item.eventType="{item}">
                                <td>{{item.eventType}}</td>
                              </template>
                              <template v-slot:item.text="{item}">
                                <td>{{item.text}}</td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment-timezone';
import Utility from './utility'
import dateSelectionPopup from '../../../../vueComponents/dateSelectionPopup/dateSelectionPopup.vue'
import LoginService from "../../../../services/login.service";
export default {
    props: {
        orgIdProp: Number
    },
    components: {
        'date-selection': dateSelectionPopup
    },
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSUPro: 'isSUPro'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        },
        dateText: function() {
            let dateFormat = 'MMM D, YYYY'
            return `${moment(this.dateValue.startDate).format(dateFormat)} - ${moment(this.dateValue.endDate).format(dateFormat)}`
        }
    },
    data() {
        return {
            minDate: moment.max([
                this.getCurrentMoment().subtract(10, 'year').startOf('month'),
                moment("1-1-2022", "MM-DD-YYYY")
            ]).toDate(),
            maxDate: this.getCurrentMoment().endOf('day').toDate(),
            dateValue: this.getDefaultDateRange(),
            auditHistory: {
                "content": [],
                "totalElements": 0
            },
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [
                // {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Org Id', align: 'left', sortable: true, value: 'orgId'},
                {text: 'Org Name', align: 'left', sortable: true, value: 'orgName'},
                {text: 'User Id', align: 'left', sortable: true, value: 'userId'},
                {text: 'Entity Id', align: 'left', sortable: false, value: 'entityId'},
                {text: 'Entity Name', align: 'left', sortable: true, value: 'entityName'},
                {text: 'Event Type', align: 'left', sortable: true, value: 'eventType'},
                {text: 'text', align: 'left', sortable: false, value: 'text'}
            ],
            entityNames: [
                {text: 'All', value: null},
                {text: 'Config', value: 'config'},
                {text: 'Endpoint', value: 'EndPoint'},
                {text: 'Integration', value: 'Integration'},
                {text: 'Monitoring Group', value: 'MonitoringGroup'},
                {text: 'Org', value: 'Org'},
                {text: 'Org Contact', value: 'OrgContact'},
                {text: 'Room', value: 'Room'},
                {text: 'VanWorkerSession', value: 'VanWorkerSession'},
                {text: 'ViSystem', value: 'ViSystem'},
                {text: 'User', value: 'User'}
            ],
            eventTypes: [
                {text: 'All', value: null},
                {text: 'Created', value: 'created'},
                {text: 'Deleted', value: 'deleted'},
                {text: 'Login', value: 'login'},
                {text: 'Monitoring Groups Updated', value: 'monitoring.groups.updated'},
                {text: 'Poll Schedules Updated', value: 'poll.schedules.updated'},
                {text: 'Soft Deleted', value: 'soft.deleted'},
                {text: 'Updated', value: 'updated'},
                {text: 'User Login', value: 'user.login'},
                {text: 'Worker Login', value: 'worker.login'}
            ],
            orgId: null,
            userId: null,
            entityId: null,
            entityName: null,
            eventType: null,
            text: null,
            showFilters: true,
            valid: false 
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        },
        orgIdProp: async function(val) {
            this.orgId = this.orgIdProp
            this.refresh(this.pagination)
        }
    },
    created() {
        this.orgId = this.orgIdProp
        if (this.orgIdProp) {
            this.headers.splice(1,2)
        }
    },
    methods: {
        async refresh(pagination) {

            const { page, itemsPerPage, sortBy, sortDesc } = pagination

            let sort = ""
            if (sortBy && sortBy.length) {
                sort = sortBy[0] + "," + (sortDesc && sortDesc.length && sortDesc[0] ? 'desc' : 'asc')
            }

            let filter = Utility.buildQueryString(['orgId', 'userId', 'entityId', 'entityName', 'eventType', 'text', 'from', 'to'],
                              [this.orgId, this.userId, this.entityId, this.entityName, this.eventType, this.text, 
                             moment(this.dateValue.startDate).subtract(1, 'days').format('YYYY-MM-DD'), moment(this.dateValue.endDate).add(1, 'days').format('YYYY-MM-DD')], ['text'])

            this.loading = true

            this.auditHistory = await this.$store.dispatch('crossorg/getAuditHistory',
                {filter, size: itemsPerPage || 10, page: page ? page - 1 : 0, sort})

            this.totalItems = this.auditHistory.totalElements

            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async resetFilters() {
            this.key = null
            this.value = null
            this.orgId = this.orgIdProp
            this.userId = null
            this.entityId = null
            this.entityName = null
            this.eventType = null
            this.text = null
            this.dateValue = this.getDefaultDateRange()

            await this.refresh(this.pagination)

        },
        async applyFilters() {
            await this.refresh(this.pagination)
        },
        handleDateRangeUpdate(dv) {
            this.dateValue = dv
        },
        getCurrentMoment() {
            return moment.tz(_.get(LoginService.userObject, 'timezoneId', ''));
        },
        getTimezoneText() {
            return _.get(LoginService.userObject, 'timezoneDisplay', '');
        },
        getDateFormat() {
            return DATE_FORMAT;
        },
        getDefaultDateRange() {
            return {
                startDate: this.getCurrentMoment().subtract(1, 'month').startOf('day'),
                endDate: this.getCurrentMoment().endOf('day')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
  .date-time-container {
      display: table-cell;
      text-align: right;
      align-self: center;

        .date-selection-wrapper {
            .dateSelection .custom-date-picker {
            padding: 10px;
            height: 40px;
            border-radius: var(--border-radius);
            border: 1px solid #D0D0D0;
            background-color: #FFFFFF;
            display: inline-block;

            #dateRangePicker {
                right: 0;
            }
        }
    }
  }
</style>